import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

const GET_MY_ACCOUNT_GRANTS = graphql(`
  query GetMyAccountGrants {
    me {
      user {
        account {
          grants {
            id
            identifier
            name
            description
            deductionType
            availableAmount {
              value
              currency {
                code
                exponent
              }
            }
            defaultForCategories
          }
        }
      }
    }
  }
`);

const useGetMyAccountGrants = (args?: { enabled?: boolean }) => {
  const { data, ...rest } = useQuery({
    enabled: args?.enabled ?? true,
    queryKey: meKeys.accountGrants(),
    queryFn: () => gqlClient.request(GET_MY_ACCOUNT_GRANTS),
  });

  return {
    grants: data?.me.user.account.grants ?? [],
    ...rest,
  };
};

export default useGetMyAccountGrants;
